module.exports = __webpack_public_path__ + "static/media/SlateLogo.66c7aae4.png";